import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { UpdateOrgGroupApiArg } from '@/__generated/es-api'
import { ERROR_SAVE_GROUPS_ITEM_SERVER } from '@/app/module/groups/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUpdateGroup = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [update, res] = esApi.endpoints.updateOrgGroup.useMutation()

  const updateGroup = useCallback(
    async (groupId: number, payload: UpdateOrgGroupApiArg['body']) => {
      try {
        await update({
          orgId: orgId.toString(),
          groupId: groupId.toString(),
          body: payload,
        }).unwrap()
        dispatch(
          createNotification({
            'update-group-success': {
              type: 'success',
              message: 'Group has been saved successfully',
            },
          }),
        )
        return true
      } catch (error) {
        dispatch(
          createNotification({
            'update-group-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_SAVE_GROUPS_ITEM_SERVER),
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, update],
  )

  return [updateGroup, res] as const
}
